// Diagnostic telemetry: fire-and-forget POST to backend so we can correlate
// what the frontend saw with backend logs. Survives unload via sendBeacon.
// Temporary — remove once the Telegram-WebView publish-toast root cause is fixed.

export function sendPublishTelemetry(payload: Record<string, unknown>): void {
  try {
    const body = JSON.stringify({ ...payload, ts: Date.now(), ua: navigator.userAgent });
    if (typeof navigator.sendBeacon === 'function') {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon('/api/telemetry/publish-result', blob);
      return;
    }
    void fetch('/api/telemetry/publish-result', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    });
  } catch {
    // best effort
  }
}
